import { createStyles, makeStyles } from '@hawkins/styles';
export function dateTimePickerStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the DatePicker calendar wrapper. */
        datePickerCalendarWrapper: {
            background: 'transparent',
        },
        /** Class name of the divider. */
        divider: {
            alignSelf: 'stretch',
            margin: "".concat(hawkinsVariables.spacings.space2, " 0"),
        },
        /** Class name of the element containing the date and time pickers. */
        pickersContainer: {
            alignItems: 'center',
            display: 'flex',
        },
        /** Class name of the footer. */
        footer: {
            borderTopColor: hawkins.ui.borderColorXlight,
            borderTopStyle: 'solid',
            borderTopWidth: hawkins.ui.borderWidthRegular,
        },
        /** Class name of the root element. */
        root: {},
    });
}
export var useDateTimePickerStyles = makeStyles(dateTimePickerStyles, { name: 'Hawkins-DateTimePicker' });
